// extracted by mini-css-extract-plugin
export default {"wrapper":"Nq-z","reviewFormSuccess":"Oq-z","header":"Pq-z","message":"Qq-z","paragraph":"Rq-z","lottieContainer":"Sq-z"};